//Import required modules
import React from 'react';
import { render } from 'react-dom'

//Import required CSS 
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';

//Import required Components
import App from './components/App';
import storeFactory from './store/storeFactory'

import {changeMedia, updateColorAttr} from './store/actions'

const store = storeFactory()

window.React = React
window.store = store

console.log(store.getState())
window.addEventListener('resize', () => 
{
    store.dispatch(changeMedia())
    store.dispatch(updateColorAttr(store.getState().userWindow))
});
// let colorClickedEle = document.createElement('textarea')
// colorClickedEle.setAttribute("id", "colorClicked");
// colorClickedEle.style.display = 'none'
// document.body.appendChild(colorClickedEle);

render(
    // <Provider store={store}>
        <App store={store}/>,
    // </Provider>,
    document.getElementById('root')
)